import React, { useState } from 'react';

import RadioButton from '../radio-button';
import './styles.scss';

interface RadioButtonListProps {
  options: string[];
  disabled?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
  // Render a non-selectable muted "|" divider BEFORE each option whose value is
  // in this set. Defaults to no divider, so existing callers are unchanged.
  dividerBefore?: string[];
}

const RadioButtonList: React.FC<RadioButtonListProps> = ({
  options,
  disabled = false,
  onChange,
  defaultValue,
  dividerBefore,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(defaultValue || null);

  const handleSelectOption = (option: string) => {
    setSelectedOption(option);

    if (onChange) {
      onChange(option);
    }
  };

  return (
    <div className="radio-button-list">
      {options.map((option) => (
        <React.Fragment key={option}>
          {dividerBefore?.includes(option) && (
            <span className="radio-button-list-divider" aria-hidden="true">
              |
            </span>
          )}
          <RadioButton
            label={option}
            value={selectedOption === option}
            setSelected={() => handleSelectOption(option)}
            disabled={disabled}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default RadioButtonList;
